import { ColumnType } from "antd/lib/table";
import { ICmsItem } from "../../../api/dto/cms/ICmsItem";
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import { EditOutlined } from "@ant-design/icons";

interface IProps {
  showForm: (id: string) => void;
}

export const GenerateCmsColumns = ({ showForm }: IProps) => {
  const { t } = useTranslation();

  const columnName: ColumnType<ICmsItem> = {
    title: t("common.title"),
    showSorterTooltip: false,
    dataIndex: "title",
    width: "60%",
    fixed: "left",
    render: (value) => <>{value}</>
  };

  const columnScheme: ColumnType<ICmsItem> = {
    title: t("sections.scheme"),
    dataIndex: "type",
    showSorterTooltip: false,
    width: "20%",
    render: (type) => <>{type}</>
  };

  const columnAction: ColumnType<ICmsItem> = {
    title: t("common.action"),
    showSorterTooltip: false,
    width: "20%",
    render: (_, entity) => (
      <>
        <Button type="link" icon={<EditOutlined />} onClick={() => showForm(entity.id || "")} />
      </>
    )
  };

  return [columnName, columnScheme, columnAction];
};
